import React from 'react'
import img1 from "../assets/images/logo/Frame178.png"
import img2 from "../assets/images/logo/Frame179.png"
import img3 from "../assets/images/logo/Frame180.png"
import img4 from "../assets/images/logo/Frame181.png"

export default function Logos() {
  return (
    <div className='container-fluid py-5'>
      <div className='row'>
        <div className="col-lg-12">
          <div className="client-list" >
            <h5 className='text-center ques'>As seen on</h5>
            <div className="row justify-content-center mt-4">
              <div className="col-md-2 col-6 d-flex justify-content-center">
                <img
                  className="img-fluid"
                  src={img1}
                  alt=""
                />
              </div>
              {/* End col*/}
              <div className="col-md-2 col-6 d-flex justify-content-center">
                <img
                  className="img-fluid"
                  src={img2}
                  alt=""
                />
              </div>
              {/* End col*/}
              <div className="col-md-2 col-6 d-flex justify-content-center">
                <img
                  className="img-fluid"
                  src={img3}
                  alt=""
                />
              </div>
              {/* End col*/}
              <div className="col-md-2 col-6 d-flex justify-content-center">
                <img
                  className="img-fluid"
                  src={img4}
                  alt=""
                />
              </div>
              {/* End col*/}
            </div>
            {/* End row*/}
          </div>
        </div>
        {/* End col*/}
      </div>
    </div>
  )
}
